// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledTopWrapper = styled.div`
	position: relative;
	padding: 1rem;
`;

// #####################################################
